"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const DesktopHeader_1 = __importDefault(require("./DesktopHeader"));
const MobileHeader_1 = __importDefault(require("./MobileHeader"));
const Header = (0, react_1.forwardRef)((props, ref) => {
    const { isAboveMd, headerMessage, goBack } = props;
    if (isAboveMd) {
        return (react_1.default.createElement(DesktopHeader_1.default, { goBack: goBack, headerMessage: headerMessage, ref: ref }));
    }
    return (react_1.default.createElement(MobileHeader_1.default, { goBack: goBack, headerMessage: headerMessage, ref: ref }));
});
Header.displayName = 'Header';
exports.default = Header;
//# sourceMappingURL=Header.js.map